<template>
    <div class="basic-layout">
        <Header/>
        <div class="content">
            <div class="page">
                <slot/>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from "./Header";
    import Footer from "./Footer";

    export default {
        name: 'MainLayout',
        components: {
            Footer,
            Header,
        },
        data() {
            return {
            }
        },
        methods:{
        },

    }
</script>

<style scoped>

</style>
